// src/models/servicos/OrdemServico.js
export const SITUACOES_OS = {
  1: 'Aberta',
  2: 'Em análise',
  3: 'Aguardando aprovação',
  4: 'Aprovada',
  5: 'Em execução',
  6: 'Aguardando peça',
  7: 'Aguardando cliente',
  8: 'Concluída',
  9: 'Entregue',
  10: 'Cancelada',
  11: 'Reprovada',
};
export const FATURAMENTOS_OS = {
  1: 'Não faturada',
  2: 'Parcialmente faturada',
  3: 'Faturada',
  4: 'Não gerar documento',
  5: 'Em processamento',
};
export const PAGAMENTOS_OS = {
  1: 'Não informado',
  2: 'Pendente',
  3: 'Parcialmente pago',
  4: 'Pago',
  5: 'Cancelado',
};
export const PRIORIDADES_OS = {
  1: 'Baixa',
  2: 'Normal',
  3: 'Alta',
  4: 'Urgente'
};
export const MEIOS_APROVACAO_OS = {
  1: 'Presencial',
  2: 'Telefone',
  3: 'WhatsApp',
  4: 'E-mail',
  5: 'Aplicativo',
  6: 'Outro'
};
export class OrdemServico {
  constructor(filialId = 0, usuarioId = 0) {
    Object.assign(this, {
      id: 0,
      filialId,
      numero: 0,
      clienteId: 0,
      clienteNome: '',
      equipamentoClienteId: null,
      tecnicoResponsavelId: null,
      situacao: 1,
      situacaoFaturamento: 1,
      situacaoPagamento: 1,
      valorFaturado: 0,
      valorPago: 0,
      valorPendente: 0,
      possuiParcelaVencida: false,
      prioridade: 2,
      problemaRelatado: '',
      observacaoEntrada: '',
      diagnostico: '',
      solucaoAplicada: '',
      observacaoInterna: '',
      observacaoCliente: '',
      previsaoConclusao: null,
      valorDesconto: 0,
      usuarioId,
      emGarantia: false,
      ordemServicoOrigemGarantiaId: null,
      garantiaDias: null,
      itens: []
    });
  }
}
export const moeda = valor => Number(valor || 0).toLocaleString('pt-BR', {
  style: 'currency',
  currency: 'BRL'
});
export const dataHora = valor => valor ? new Date(valor).toLocaleString('pt-BR') : '-';
